import type { OutreachDraft, OutreachPayload, OutreachEngagement } from '../types';

function eng(o: Partial<OutreachEngagement>): OutreachEngagement {
  return {
    engagementStatus: 'Active', accountDisplayName: o.accountName ?? null, opportunityId: 'opp', opportunityName: null, accountName: null, coacheeName: null,
    projectNumber: null, hoursContracted: null, hoursCompleted: 0, hoursRemaining: null,
    sowStartDate: null, sowEndDate: null, lastSessionDate: null, daysSinceLastSession: null,
    daysSinceStart: null, sourceAlertType: 'stalled_start', ledgerNote: null, ...o,
  };
}

const STALLED_BODY = (name: string, lines: string) =>
  `Hi ${name},\n\nI hope you're well. In reviewing our active coaching engagements, I see the following engagement that started more than 14 days ago but doesn't yet have any coaching hours logged in Coaching.com:\n\n${lines}\n\nWhen you have a moment, could you log any completed hours in Coaching.com? If you've had trouble getting started or scheduling, just reply to this email with any context and we'll help.\n\nThank you!\n\nKindly,\nDanielle & The Ariel Team`;

export const OUTREACH_MOCK: OutreachPayload = {
  run: {
    id: 'mock-run',
    generatedAt: new Date().toISOString(),
    workflow: 'stalled_start',
    draftsCount: 3,
    engagementsCount: 3,
    suppressedCount: 0,
  },
  drafts: [
    {
      id: 'd1', runId: 'mock-run', workflow: 'stalled_start',
      recipientName: 'Bob Morris', recipientEmail: 'bmorris@affiliate-arielgroup.com',
      coachName: 'Bob Morris', coachEmail: 'bmorris@affiliate-arielgroup.com',
      subject: 'Ariel coaching — an engagement awaiting its first logged session',
      bodyMd: STALLED_BODY('Bob', '- Illinois Tool Works Inc. — ITW - Ishwar Patil, P&F LFP 2026: 0 of 10 hours logged, started 2026-06-01 (17 days ago)'),
      status: 'pending_review', reviewedByEmail: null, reviewedAt: null, rejectReason: null,
      engagements: [eng({ opportunityId: 'o1', opportunityName: 'ITW - Ishwar Patil, P&F LFP 2026', accountName: 'Illinois Tool Works Inc.', hoursContracted: 10, hoursRemaining: 10, sowStartDate: '2026-06-01', daysSinceStart: 17 })],
    },
    {
      id: 'd2', runId: 'mock-run', workflow: 'stalled_start',
      recipientName: 'Jay Fehnel', recipientEmail: 'jfehnel@affiliate-arielgroup.com',
      coachName: 'Jay Fehnel', coachEmail: 'jfehnel@affiliate-arielgroup.com',
      subject: 'Ariel coaching — an engagement awaiting its first logged session',
      bodyMd: STALLED_BODY('Jay', '- Cisco — Olivia Shone: 0 of 25 hours logged, started 2026-05-01 (47 days ago)'),
      status: 'approved', reviewedByEmail: 'danielle@arielgroup.com', reviewedAt: new Date().toISOString(), rejectReason: null,
      engagements: [eng({ opportunityId: 'o2', opportunityName: 'Olivia Shone', accountName: 'Cisco', hoursContracted: 25, hoursRemaining: 25, sowStartDate: '2026-05-01', daysSinceStart: 47 })],
    },
    {
      id: 'd3', runId: 'mock-run', workflow: 'stalled_start',
      recipientName: 'Elena Chopin', recipientEmail: null,
      coachName: 'Elena Chopin', coachEmail: null,
      subject: 'Ariel coaching — an engagement awaiting its first logged session',
      bodyMd: STALLED_BODY('Elena', '- Northwestern University — Counseling Services Center: 0 of 113.5 hours logged, started 2026-05-20 (28 days ago)'),
      status: 'blocked', reviewedByEmail: null, reviewedAt: null, rejectReason: null,
      engagements: [eng({ opportunityId: 'o3', opportunityName: 'Counseling Services Center', accountName: 'Northwestern University', hoursContracted: 113.5, hoursRemaining: 113.5, sowStartDate: '2026-05-20', daysSinceStart: 28 })],
    },
  ],
};

export function withMockDraftStatus(
  payload: OutreachPayload,
  id: string,
  status: OutreachDraft['status'],
): OutreachPayload {
  return { ...payload, drafts: payload.drafts.map((d) => (d.id === id ? { ...d, status } : d)) };
}
